module.exports = __webpack_public_path__ + "static/media/icon-ontario.b875a244.svg";